module.exports = __webpack_public_path__ + "media/images/icons/material/blog-be4cfe50bb746a3db1c3c63234399b50.svg";